<!-- features/countries/page/country-upsert/country-upsert.html -->
@if (editingId) {
  <ui-organism-main-nav [mainText]="'countries.form.editTitle' | translate"> </ui-organism-main-nav>
} @else {
  <ui-organism-main-nav [mainText]="'countries.form.createTitle' | translate">
  </ui-organism-main-nav>
}

<ui-atom-spacer />
<ui-atom-text type="medium" [text]="'countries.form.subtitle' | translate"> </ui-atom-text>
<ui-atom-spacer size="spacer-xxl" />

<section class="country-upsert-form">
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="country-upsert-form__grid"
    autocomplete="off"
  >
    <!-- Nombre -->
    <div class="country-upsert-form__field">
      <ui-molecule-input
        textId="name"
        formControlName="name"
        [label]="'countries.form.name.label' | translate"
        [placeholder]="'countries.form.name.placeholder' | translate"
        required="true"
      >
      </ui-molecule-input>
      <div
        class="ui-input-error-container"
        [class.hidden]="!nameControl?.touched || nameControl?.valid"
      >
        @if (nameControl?.hasError('required')) {
          <span>{{ 'countries.form.name.error.required' | translate }}</span>
        }
        @if (nameControl?.hasError('minlength')) {
          <span>{{ 'countries.form.name.error.minLength' | translate }}</span>
        }
        @if (nameControl?.hasError('maxlength')) {
          <span>{{ 'countries.form.name.error.maxLength' | translate }}</span>
        }
      </div>
    </div>

    <!-- Acciones -->
    <div class="country-upsert-form__actions">
      <ui-atom-button
        type="button"
        rules="main"
        styling="outlined"
        [withShadow]="false"
        [text]="'countries.form.actions.cancel' | translate"
        (click)="cancel()"
      >
      </ui-atom-button>

      <ui-atom-button
        type="button"
        rules="main"
        styling="filled"
        [withShadow]="true"
        [disabled]="isLoading"
        [text]="
          editingId
            ? ('countries.form.actions.save' | translate)
            : ('countries.form.actions.create' | translate)
        "
        (click)="onSubmit()"
      >
      </ui-atom-button>
    </div>
  </form>
</section>
